export interface FeatureFlags {
  coverLetter: boolean;
  clientProposal: boolean;
}

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  coverLetter: false,
  clientProposal: false,
};

export const isFeatureEnabled = (flagName: keyof FeatureFlags): boolean => {
  return localStorage.getItem(flagName) === 'true';
};

export const enableFeature = (flagName: keyof FeatureFlags): void => {
  localStorage.setItem(flagName, 'true');
};

export const disableFeature = (flagName: keyof FeatureFlags): void => {
  localStorage.setItem(flagName, 'false');
}; 